import React from 'react';
import { IconButton, Badge } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useSelector, useDispatch } from 'react-redux';
import { setCartOpen } from '../../redux/slices/catalogCartSlice';

export const CartButton = ({ color = '#fff' }) => {
  const dispatch = useDispatch();
  const { items } = useSelector((state) => state.catalogCart);
  const itemCount = items.reduce((sum, item) => sum + item.quantity, 0);

  const handleCartClick = () => {
    dispatch(setCartOpen(true));
  };

  return (
    <IconButton
      onClick={handleCartClick}
      sx={{
        color: color,
        padding: 1.7,
        '&:hover': {
          backgroundColor: 'rgba(255,255,255,0.1)'
        }
      }}
    >
      <Badge badgeContent={itemCount} color="error">
        <ShoppingCartIcon sx={{ fontSize: 28 }} />
      </Badge>
    </IconButton>
  );
};
